import React, { FC, useMemo, useState } from 'react';
import { compareStrings, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { isInternalTech } from '../../utils/AuthUtils';

const ProposalOnBehalfOfSupplierButton = ({
	bidder,
	requestForProposal,
	history,
	userType,
	currentUser,
}) => {
	const isBuyerManagerOrInternalTech = useMemo(
		() =>
			(userType === ROLE_TYPES.BUYER &&
				currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role))) ||
			isInternalTech(currentUser),
		[userType, currentUser]
	);
	const bidderStatus = useMemo(() => nullSafeGet('bidderStatus', bidder), [bidder]);
	const sameCreator = useMemo(
		() => compareStrings(nullSafeGetOrElse('proposal.createdBy', bidder, ''), currentUser.email),
		[currentUser, bidder]
	);
	if (!isBuyerManagerOrInternalTech) return null;
	return (compareStrings(bidderStatus, 'noResponse') ||
		compareStrings(bidderStatus, 'interested')) &&
		nullSafeGetOrElse('status', requestForProposal, 'draft') === 'active' ? (
		<Button
			onClick={() =>
				history.push(
					`/${userType}/requestsForProposal/detail/${
						requestForProposal.id
					}/newProposal?workOrderId=${nullSafeGet(
						'workOrder.id',
						requestForProposal
					)}&supplierFacilityId=${nullSafeGet('supplierFacilityId', bidder)}`
				)
			}
		>
			Create Proposal
		</Button>
	) : compareStrings(bidderStatus, 'bidding') && sameCreator ? (
		<Button
			onClick={() =>
				history.push(
					`/${userType}/requestsForProposal/editProposal?proposalId=${nullSafeGetOrElse(
						'proposal.id',
						bidder,
						''
					)}&workOrderId=${nullSafeGet(
						'workOrder.id',
						requestForProposal
					)}&supplierFacilityId=${nullSafeGet(
						'supplierFacilityId',
						bidder
					)}&requestForProposalId=${nullSafeGet('id', requestForProposal)}`
				)
			}
		>
			Edit Proposal
		</Button>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(ProposalOnBehalfOfSupplierButton))
);
